'use client'
import React, { useState, useEffect, useRef } from 'react'
import Image from 'next/image'
import LinkComponent from './LinkComponent'
import { sendGAEvent } from '@next/third-parties/google'

// ─── Inline SVG icons ─────────────────────────────────────────────────────────

const SvgIcons = {
  none: null,
  location: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>,
  price:    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>,
  building: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="2" width="16" height="20" rx="2"/><path d="M9 22v-4h6v4"/><path d="M8 6h.01"/><path d="M16 6h.01"/><path d="M12 6h.01"/><path d="M12 10h.01"/><path d="M12 14h.01"/><path d="M16 10h.01"/><path d="M16 14h.01"/><path d="M8 10h.01"/><path d="M8 14h.01"/></svg>,
  tag:      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"/><circle cx="7.5" cy="7.5" r=".5" fill="currentColor"/></svg>,
  star:     <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>,
  ruler:    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z"/><path d="m14.5 12.5 2-2"/><path d="m11.5 9.5 2-2"/><path d="m8.5 6.5 2-2"/><path d="m17.5 15.5 2-2"/></svg>,
  video:    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m22 8-6 4 6 4V8z"/><rect x="2" y="6" width="14" height="12" rx="2"/></svg>,
  cube:     <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>,
  waves:    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"/><path d="M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"/><path d="M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"/></svg>,
  mountain: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m8 3 4 8 5-5 5 15H2L8 3z"/></svg>,
  transit:  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="3" width="16" height="16" rx="2"/><path d="M4 11h16"/><path d="M12 3v8"/><path d="M8 19l-2 3"/><path d="M18 22l-2-3"/><path d="M8 15h0"/><path d="M16 15h0"/></svg>,
  paw:      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="4" r="2"/><circle cx="18" cy="8" r="2"/><circle cx="4" cy="8" r="2"/><path d="M9.3 14a5 5 0 0 0-2.5 4.4V21h8.4v-2.6a5 5 0 0 0-2.5-4.4 3.7 3.7 0 0 0-3.4 0z"/><circle cx="18" cy="14" r="2"/></svg>,
  clock:    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
  home:     <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
}

// ─── Construction status ──────────────────────────────────────────────────────

const CONSTRUCTION_STATUS = [
  { id: 'completed',          label: 'Completed',          color: '#10b981' },
  { id: 'under_construction', label: 'Under Construction', color: '#f59e0b' },
  { id: 'off_plan',           label: 'Off Plan',           color: '#6366f1' },
]

// ─── Transit lines ────────────────────────────────────────────────────────────

const TRANSIT_LINES = [
  { id: 'bts_sukhumvit', abbr: 'BTS', color: '#7db71f', textColor: '#fff' },
  { id: 'bts_silom',     abbr: 'BTS', color: '#007a3d', textColor: '#fff' },
  { id: 'mrt_blue',      abbr: 'MRT', color: '#1a3e8f', textColor: '#fff' },
  { id: 'mrt_purple',    abbr: 'MRT', color: '#7b2d8b', textColor: '#fff' },
  { id: 'arl',           abbr: 'ARL', color: '#e0251b', textColor: '#fff' },
  { id: 'brt',           abbr: 'BRT', color: '#f37021', textColor: '#fff' },
  { id: 'mrt_yellow',    abbr: 'MRT', color: '#f5c400', textColor: '#000' },
  { id: 'mrt_pink',      abbr: 'MRT', color: '#e4007f', textColor: '#fff' },
]

// ─── RTL helpers ──────────────────────────────────────────────────────────────

// Converts stored 'left'/'right' → logical 'start'/'end'
// textAlign and justifyContent using 'start'/'end' respect dir="rtl" natively
const ALIGN_MAP = { left: 'start', right: 'end', center: 'center', start: 'start', end: 'end' }
const normalizeAlign = (align) => ALIGN_MAP[align] ?? 'start'
const toJustify      = (align) => align === 'center' ? 'center' : align === 'end' ? 'flex-end' : 'flex-start'

// ─── Style helpers ────────────────────────────────────────────────────────────

function badgeChipStyle(b, onImage = false) {
  const variant = b.variant ?? 'filled', radius = b.radius ?? 20
  const fontSize = b.fontSize ?? 0.65, fontWeight = b.fontWeight ?? '600'
  let bg, color, border
  if (variant === 'filled')        { bg = onImage ? `${b.color}dd` : b.color; color = '#fff'; border = 'none' }
  else if (variant === 'outlined') { bg = 'transparent'; color = b.color; border = `1.5px solid ${b.color}` }
  else                             { bg = `${b.color}20`; color = b.color; border = `1px solid ${b.color}35` }
  return { display: 'inline-flex', alignItems: 'center', gap: 3, background: bg, color, border, fontSize: `${fontSize}rem`, fontWeight, padding: '3px 8px', borderRadius: radius, backdropFilter: onImage ? 'blur(4px)' : undefined, lineHeight: 1.4 }
}

function constructionStatusChipStyle(field, onImage = false) {
  const status   = CONSTRUCTION_STATUS.find(s => s.id === (field.value ?? 'completed')) ?? CONSTRUCTION_STATUS[0]
  const variant  = field.variant ?? 'subtle', radius = field.radius ?? 20
  const fontSize = field.fontSize ?? 0.75, fontWeight = field.fontWeight ?? '600'
  let bg, color, border
  if (variant === 'filled')        { bg = onImage ? `${status.color}dd` : status.color; color = '#fff'; border = 'none' }
  else if (variant === 'outlined') { bg = 'transparent'; color = status.color; border = `1.5px solid ${status.color}` }
  else                             { bg = `${status.color}20`; color = status.color; border = `1px solid ${status.color}35` }
  return { display: 'inline-flex', alignItems: 'center', gap: 3, background: bg, color, border, fontSize: `${fontSize}rem`, fontWeight, padding: '3px 8px', borderRadius: radius, backdropFilter: onImage ? 'blur(4px)' : undefined, lineHeight: 1.4 }
}

// ─── Label style helpers ──────────────────────────────────────────────────────

function labelBg(field) {
  if ((field.bgType ?? 'solid') === 'gradient') return field.bgGradient ?? 'linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)'
  return field.bg ?? '#2563eb'
}

function labelBorderRadius(field, brandRadiusMd) {
  const v = brandRadiusMd ?? '0.375rem'
  const brandPx = String(v).endsWith('rem') ? Math.round(parseFloat(v) * 16) : (parseInt(v) || 6)
  const tl = field.radiusTL ?? brandPx, tr = field.radiusTR ?? brandPx
  const br = field.radiusBR ?? brandPx, bl = field.radiusBL ?? brandPx
  return (field.radiusLinked !== false) ? tl : `${tl}px ${tr}px ${br}px ${bl}px`
}

function labelStyle(field, brandRadiusMd) {
  return {
    display: 'inline-flex', alignItems: 'center', gap: 4,
    background: labelBg(field), color: field.color ?? '#ffffff',
    fontSize: `${field.fontSize ?? 0.75}rem`, fontWeight: field.fontWeight ?? '600',
    padding: `${field.paddingY ?? 3}px ${field.paddingX ?? 8}px`,
    border: (field.borderWidth ?? 0) > 0 ? `${field.borderWidth}px solid ${field.borderColor ?? '#ffffff'}` : 'none',
    borderRadius: labelBorderRadius(field, brandRadiusMd),
    lineHeight: 1.4,
  }
}

// insetInlineStart/End replace left/right so positions flip correctly in RTL
function labelPositionStyle(field) {
  const ox = field.positionOffsetX ?? 10, oy = field.positionOffsetY ?? 10
  const base = { position: 'absolute', display: 'flex', flexDirection: 'column', gap: 4, zIndex: 2 }
  switch (field.position) {
    case 'top-left':      return { ...base, top: oy, insetInlineStart: ox }
    case 'top-center':    return { ...base, top: oy, left: '50%', transform: 'translateX(-50%)', alignItems: 'center' }
    case 'top-right':     return { ...base, top: oy, insetInlineEnd: ox, alignItems: 'flex-end' }
    case 'bottom-left':   return { ...base, bottom: oy, insetInlineStart: ox }
    case 'bottom-center': return { ...base, bottom: oy, left: '50%', transform: 'translateX(-50%)', alignItems: 'center' }
    case 'bottom-right':  return { ...base, bottom: oy, insetInlineEnd: ox, alignItems: 'flex-end' }
    default:              return { ...base, top: oy, insetInlineStart: ox }
  }
}

// ─── Sub-components ───────────────────────────────────────────────────────────

function RefChip({ field, value, onImage = false }) {
  const displayType = field.displayType ?? 'text'
  const color       = field.badgeColor ?? field.color ?? '#6b7280'
  const fontSize    = field.fontSize   ?? 0.7
  const fontWeight  = field.fontWeight ?? '500'
  const radius      = field.radius     ?? 4
  if (displayType === 'badge') {
    const variant = field.variant ?? 'outlined'
    let bg, textColor, border
    if (variant === 'filled')        { bg = color; textColor = '#fff'; border = 'none' }
    else if (variant === 'outlined') { bg = onImage ? 'rgba(0,0,0,0.3)' : 'transparent'; textColor = onImage ? '#fff' : color; border = `1.5px solid ${onImage ? 'rgba(255,255,255,0.7)' : color}` }
    else                             { bg = `${color}20`; textColor = color; border = `1px solid ${color}35` }
    return <span style={{ display: 'inline-flex', alignItems: 'center', background: bg, color: textColor, border, fontSize: `${fontSize}rem`, fontWeight, padding: '2px 8px', borderRadius: radius, backdropFilter: onImage ? 'blur(4px)' : undefined, lineHeight: 1.4 }}>{value}</span>
  }
  return <span style={{ fontSize: `${fontSize}rem`, fontWeight, color: onImage ? 'rgba(255,255,255,0.85)' : (field.color ?? '#6b7280'), textShadow: onImage ? '0 1px 3px rgba(0,0,0,0.5)' : undefined }}>{value}</span>
}

function TransitBlock({ field, compact }) {
  const lines = (field.transitLines ?? []).filter(tl => tl.lineId)
  if (!lines.length) return null
  const displayType = field.displayType ?? 'badge'
  const variant     = field.variant     ?? 'filled'
  const showIcon    = field.showIcon    ?? true
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginBottom: compact ? 0 : 4 }}>
      {lines.map((tl, i) => {
        const brand     = TRANSIT_LINES.find(l => l.id === tl.lineId) ?? TRANSIT_LINES[0]
        const chipLabel = `${brand.abbr}${tl.station ? ` · ${tl.station}` : ''}${tl.distance ? ` ${tl.distance}` : ''}`
        if (displayType === 'text') return (
          <span key={i} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: `${field.fontSize}rem`, fontWeight: field.fontWeight ?? '600', color: brand.color }}>
            {showIcon && <span style={{ display: 'flex', flexShrink: 0 }}>{SvgIcons.transit}</span>}
            {chipLabel}
          </span>
        )
        let bgColor, textColor, border
        if (variant === 'filled')        { bgColor = brand.color; textColor = brand.textColor; border = 'none' }
        else if (variant === 'outlined') { bgColor = 'transparent'; textColor = brand.color; border = `1.5px solid ${brand.color}` }
        else                             { bgColor = `${brand.color}18`; textColor = brand.color; border = `1px solid ${brand.color}30` }
        return (
          <span key={i} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, background: bgColor, color: textColor, border, fontSize: `${field.fontSize}rem`, fontWeight: field.fontWeight ?? '600', padding: compact ? '2px 6px' : '3px 8px', borderRadius: field.radius ?? 20, backdropFilter: compact ? 'blur(4px)' : undefined, lineHeight: 1.4 }}>
            {showIcon && <span style={{ display: 'flex', flexShrink: 0, opacity: 0.9 }}>{SvgIcons.transit}</span>}
            {chipLabel}
          </span>
        )
      })}
    </div>
  )
}

// ─── Project data → field values hydration ───────────────────────────────────

function hydrateFields(fields, project, { lang = 'en' } = {}) {
  const ml = (val) => {
    if (val === null || val === undefined) return ''
    if (typeof val !== 'object') return String(val)
    if (Array.isArray(val)) return ''
    if (val[lang] !== undefined) return String(val[lang])
    if (val['en'] !== undefined) return String(val['en'])
    if (val.name !== undefined) return ml(val.name)
    return ''
  }

  const district    = project.districts?.[0]
  const locationStr = [
    district?.subdistrictName?.[lang] ?? district?.subdistrict,
    ml(project.location),
  ].filter(Boolean).join(', ')

  return fields.map(field => {
    if (field.isDivider) return field
    switch (field.id) {
      case 'label':
        return { ...field, value: ml(project.promotionTitle) || '', enabled: field.enabled && !!project.promotionTitle }
      case 'name':
        return { ...field, value: ml(project.name) }
      case 'startingPrice':
        return { ...field, value: ml(project.startingPrice ?? project.priceFrom ?? project.price) }
      case 'developer':
        return { ...field, value: ml(project.developer ?? project.developerName) }
      case 'location':
        return { ...field, value: locationStr }
      case 'constructionStatus':
        return { ...field, value: project.type ?? project.constructionStatus ?? 'completed' }
      case 'ref':
        return { ...field, value: project.ref ?? project.referenceId ?? project.id ?? '' }
      case 'transit':
        if (project.publicTransport?.length) {
          const mapped = project.publicTransport.map(t => ({
            lineId:   resolveTransitLineId(t),
            station:  t.transportName?.[lang] ?? t.stationName ?? '',
            distance: t.distance ?? '',
          }))
          return { ...field, transitLines: mapped }
        }
        return { ...field, enabled: false, transitLines: [] }
      default:
        return field
    }
  })
}

function resolveTransitLineId(transport) {
  const type      = (transport.type      ?? '').toLowerCase()
  const lineColor = (transport.lineColor ?? '').toLowerCase()
  const color     = (transport.colorCode ?? '').toLowerCase()
  if (type === 'brt') return 'brt'
  if (type === 'arl') return 'arl'
  if (type === 'bts') return lineColor.includes('dark') ? 'bts_silom' : 'bts_sukhumvit'
  if (type === 'mrt') {
    if (lineColor.includes('purple'))                    return 'mrt_purple'
    if (lineColor.includes('yellow'))                    return 'mrt_yellow'
    if (lineColor.includes('pink'))                      return 'mrt_pink'
    if (color.includes('7b2'))                           return 'mrt_purple'
    if (color.includes('f5c') || color.includes('gold')) return 'mrt_yellow'
    if (color.includes('e4007'))                         return 'mrt_pink'
    return 'mrt_blue'
  }
  return 'mrt_blue'
}

function hydrateBadges(badges, project) {
  const flagMap = {
    seaview:      !!project.isSeaView      || !!project.seaview,
    beachfront:   !!project.isBeachfront   || !!project.beachfront,
    petfriendly:  !!project.isPetFriendly  || !!project.petFriendly,
    foreignquota: !!project.foreignQuota,
    mountainview: !!project.isMountainView || !!project.mountainView,
    video:        !!project.videoUrl,
    walkthrough:  !!project.walkthroughUrl || !!project.tour3dUrl,
  }
  return badges.map(b => ({ ...b, enabled: b.enabled && (flagMap[b.id] ?? false) }))
}

// ─── Image overlay layer ──────────────────────────────────────────────────────

function CardImageOverlays({ fields, badges, brandRadiusMd }) {
  const enabledBadgesOnImage = badges.filter(b => b.enabled && b.showOnImage)
  const labelField           = fields.find(f => f.id === 'label' && f.enabled)

  return (
    <>
      {labelField?.showOnImage && (
        <div style={labelPositionStyle(labelField)}>
          <span style={labelStyle(labelField, brandRadiusMd)}>
            {labelField.icon !== 'none' && SvgIcons[labelField.icon]}
            {labelField.value}
          </span>
        </div>
      )}

      {/* insetInlineStart/End replace left/right — badges sit correctly in RTL */}
      {enabledBadgesOnImage.length > 0 && (
        <div style={{ position: 'absolute', bottom: 10, insetInlineStart: 10, insetInlineEnd: 10, display: 'flex', flexWrap: 'wrap', gap: 4, zIndex: 2 }}>
          {enabledBadgesOnImage.map(b => (
            <span key={b.id} style={badgeChipStyle(b, true)}>{SvgIcons[b.icon]}{b.label}</span>
          ))}
        </div>
      )}

      {/* Transit overlay at the visual inline-end edge */}
      {fields.filter(f => f.isTransit && f.enabled && f.showOnImage).map(field => (
        <div key={field.id} style={{ position: 'absolute', bottom: 10, insetInlineEnd: 10, display: 'flex', flexDirection: 'column', gap: 3, alignItems: 'flex-end', zIndex: 2 }}>
          <TransitBlock field={field} compact />
        </div>
      ))}

      {fields.filter(f => f.isRef && f.enabled && f.showOnImage).map(field => (
        <div key={field.id} style={labelPositionStyle(field)}>
          <RefChip field={field} value={field.value} onImage />
        </div>
      ))}
    </>
  )
}

// ─── Gallery slider ───────────────────────────────────────────────────────────

function GallerySlider({ images, alt, blur }) {
  const [index, setIndex]     = useState(0)
  const [hovered, setHovered] = useState(false)
  const touchStart            = useRef(null)
  const total                 = images?.length ?? 0
  if (!total) return null

  const prev = (e) => { e.preventDefault(); e.stopPropagation(); setIndex(i => (i - 1 + total) % total) }
  const next = (e) => { e.preventDefault(); e.stopPropagation(); setIndex(i => (i + 1) % total) }
  const onTouchStart = (e) => { touchStart.current = e.touches[0].clientX }
  const onTouchEnd   = (e) => {
    if (touchStart.current === null) return
    const delta = touchStart.current - e.changedTouches[0].clientX
    if (Math.abs(delta) > 40) delta > 0 ? setIndex(i => (i + 1) % total) : setIndex(i => (i - 1 + total) % total)
    touchStart.current = null
  }

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}
      onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}
      onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}
    >
      {images.map((src, i) => (
        <div key={i} style={{ position: 'absolute', inset: 0, opacity: i === index ? 1 : 0, transition: 'opacity 0.3s ease', pointerEvents: i === index ? 'auto' : 'none' }}>
          <Image placeholder={i === 0 && blur ? 'blur' : 'empty'} blurDataURL={i === 0 ? blur : undefined} src={src} fill alt={`${alt} ${i + 1}`} style={{ objectFit: 'cover' }} />
        </div>
      ))}
      {total > 1 && (
        <>
          {/* insetInlineStart/End so buttons stay at the correct visual edges in RTL */}
          <button onClick={prev} style={{ position: 'absolute', insetInlineStart: 8, top: '50%', transform: 'translateY(-50%)', zIndex: 4, background: 'rgba(0,0,0,0.35)', border: 'none', borderRadius: '50%', width: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#fff', backdropFilter: 'blur(4px)', padding: 0, opacity: hovered ? 1 : 0, transition: 'opacity 0.2s ease' }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
          </button>
          <button onClick={next} style={{ position: 'absolute', insetInlineEnd: 8, top: '50%', transform: 'translateY(-50%)', zIndex: 4, background: 'rgba(0,0,0,0.35)', border: 'none', borderRadius: '50%', width: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#fff', backdropFilter: 'blur(4px)', padding: 0, opacity: hovered ? 1 : 0, transition: 'opacity 0.2s ease' }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6"/></svg>
          </button>
          <div style={{ position: 'absolute', bottom: 8, left: 0, right: 0, display: 'flex', justifyContent: 'center', gap: 5, zIndex: 4, opacity: hovered ? 1 : 0, transition: 'opacity 0.2s ease' }}>
            {images.map((_, i) => (
              <button key={i} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setIndex(i) }}
                style={{ width: i === index ? 16 : 6, height: 6, borderRadius: 3, border: 'none', padding: 0, cursor: 'pointer', background: i === index ? '#fff' : 'rgba(255,255,255,0.5)', transition: 'all 0.2s ease' }} />
            ))}
          </div>
          {/* Counter chip at inline-start so it doesn't overlap the like button */}
          <div style={{ position: 'absolute', top: 8, insetInlineStart: 8, zIndex: 4, background: 'rgba(0,0,0,0.4)', color: '#fff', fontSize: '0.65rem', fontWeight: 600, padding: '2px 7px', borderRadius: 20, backdropFilter: 'blur(4px)', letterSpacing: '0.04em', opacity: hovered ? 1 : 0, transition: 'opacity 0.2s ease' }}>
            {index + 1} / {total}
          </div>
        </>
      )}
    </div>
  )
}

// ─── Main LargeProjectCard ────────────────────────────────────────────────────

const LargeProjectCard = ({
  project,
  cardStyle,
  gallerySlider = false,
  newLimit,
  isLast,
  lang = 'en',
  brandRadiusMd,
}) => {
  const cardRef = useRef()

  useEffect(() => {
    if (!cardRef?.current || !isLast) return
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { newLimit?.(); observer.unobserve(entry.target) }
    })
    observer.observe(cardRef.current)
    return () => observer.disconnect()
  }, [isLast])

  if (!cardStyle?.fields || !cardStyle?.badges || !cardStyle?.card) return null

  const { card }               = cardStyle
  const hydratedFields         = hydrateFields(cardStyle.fields, project, { lang })
  const hydratedBadges         = hydrateBadges(cardStyle.badges, project)
  const resolvedSlider         = gallerySlider || (card.gallerySlider ?? false)
  const enabledBadgesInContent = hydratedBadges.filter(b => b.enabled && !b.showOnImage)

  return (
    <div
      ref={cardRef}
      style={{ width: '100%', background: card.bg, borderRadius: card.radius, border: card.borderWidth > 0 ? `${card.borderWidth}px solid ${card.borderColor}` : 'none', boxShadow: card.shadow, overflow: 'hidden', position: 'relative', cursor: 'pointer' }}
      onClick={() => sendGAEvent(
      'event',
      'select_project',
      {
        project_id:       project.ref || project.id,
        project_name:     project.name,
        project_location: project.districts?.[0]?.subdistrictName?.['en'],
        project_status:   project.constructionStatus,
      })}
    >
      <LinkComponent href={`/projects/${project.slug}`}>

        {/* Image */}
        <div style={{ position: 'relative', aspectRatio: card.imageRatio ?? '4/3', overflow: 'hidden', borderRadius: card.imageRadius }}>
          {resolvedSlider && project.gallery?.length > 0 ? (
            <GallerySlider images={project.gallery} alt={project.slug ?? project.name} blur={project.blur} />
          ) : (
            <Image
              placeholder="blur"
              blurDataURL={project.blur}
              src={project.cover || '/images/loader.jpg'}
              fill
              alt={project.slug ?? project.name}
              style={{ objectFit: 'cover' }}
            />
          )}
          <CardImageOverlays fields={hydratedFields} badges={hydratedBadges} brandRadiusMd={brandRadiusMd} />
        </div>

        {/* Text content */}
        <div style={{ padding: card.contentPadding }}>
          {hydratedFields.filter(f => (f.enabled && f.id !== 'label') || f.isDivider).map(field => {

            if (field.isDivider) return (
              <div key={field.id} style={{ marginTop: field.marginTop ?? 6, marginBottom: field.marginBottom ?? 6, borderTop: `${field.thickness ?? 1}px ${field.style ?? 'solid'} ${field.color ?? '#e5e7eb'}` }} />
            )

            // ── Name ────────────────────────────────────────────────────────
            if (field.id === 'name') {
              const clamp  = field.lineClamp ?? 2
              const lineH  = 1.3
              const height = field.fixedHeight ? `${clamp * lineH * field.fontSize}rem` : undefined
              const align  = normalizeAlign(field.align)
              return (
                <div key={field.id} style={{ textAlign: align, marginBottom: 4, background: field.bg !== 'transparent' ? field.bg : undefined, padding: field.bg !== 'transparent' ? '2px 6px' : 0, borderRadius: field.bg !== 'transparent' ? 4 : 0, height, overflow: 'hidden' }}>
                  <span style={{ display: '-webkit-box', WebkitLineClamp: clamp, WebkitBoxOrient: 'vertical', overflow: 'hidden', fontSize: `${field.fontSize}rem`, fontWeight: field.fontWeight, color: field.color, lineHeight: lineH }}>
                    {/* marginInlineEnd flips automatically with dir="rtl" */}
                    {field.icon && field.icon !== 'none' && <span style={{ opacity: 0.7, marginInlineEnd: 5 }}>{SvgIcons[field.icon]}</span>}
                    {field.value}
                  </span>
                </div>
              )
            }

            // ── Construction status ──────────────────────────────────────────
            if (field.isConstructionStatus) {
              const status = CONSTRUCTION_STATUS.find(s => s.id === field.value) ?? CONSTRUCTION_STATUS[0]
              const align  = normalizeAlign(field.align ?? 'start')
              if (field.displayType === 'text') return (
                <div key={field.id} style={{ textAlign: align, marginBottom: 4, visibility: field.value ? 'visible' : 'hidden' }}>
                  <span style={{ fontSize: `${field.fontSize}rem`, fontWeight: field.fontWeight, color: status.color }}>
                    {status.label || '\u00A0'}
                  </span>
                </div>
              )
              return (
                <div key={field.id} style={{ textAlign: align, marginBottom: 4, visibility: field.value ? 'visible' : 'hidden' }}>
                  <span style={constructionStatusChipStyle(field, false)}>{status.label || '\u00A0'}</span>
                </div>
              )
            }

            // ── Transit ──────────────────────────────────────────────────────
            if (field.isTransit) {
              if (field.showOnImage) return null
              const hasLines = (field.transitLines ?? []).length > 0
              return (
                <div key={field.id} style={{ visibility: hasLines ? 'visible' : 'hidden' }}>
                  <TransitBlock field={field} />
                </div>
              )
            }

            // ── Ref chip ─────────────────────────────────────────────────────
            if (field.isRef) {
              if (field.showOnImage) return null
              const align = normalizeAlign(field.align ?? 'start')
              return (
                <div key={field.id} style={{ textAlign: align, marginBottom: 4, visibility: field.value ? 'visible' : 'hidden' }}>
                  <RefChip field={field} value={field.value || '\u00A0'} />
                </div>
              )
            }

            // ── Generic field (price, location, developer, etc.) ─────────────
            const align = normalizeAlign(field.align)
            return (
              <div key={field.id} style={{
                textAlign: align, marginBottom: 4,
                visibility: field.value ? 'visible' : 'hidden',
                background: field.bg !== 'transparent' ? field.bg : undefined,
                padding: field.bg !== 'transparent' ? '2px 6px' : 0,
                borderRadius: field.bg !== 'transparent' ? 4 : 0,
              }}>
                <span style={{
                  display: 'inline-flex', alignItems: 'center', gap: 5,
                  fontSize: `${field.fontSize}rem`, fontWeight: field.fontWeight, color: field.color,
                  // toJustify maps 'start'→'flex-start', 'end'→'flex-end', 'center'→'center'
                  justifyContent: toJustify(align),
                }}>
                  {field.icon && field.icon !== 'none' && <span style={{ opacity: 0.7, flexShrink: 0 }}>{SvgIcons[field.icon]}</span>}
                  {field.value || '\u00A0'}
                </span>
              </div>
            )
          })}

          {enabledBadgesInContent.length > 0 && (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, marginTop: 8 }}>
              {enabledBadgesInContent.map(b => (
                <span key={b.id} style={badgeChipStyle(b, false)}>{SvgIcons[b.icon]}{b.label}</span>
              ))}
            </div>
          )}
        </div>

      </LinkComponent>
    </div>
  )
}

export default LargeProjectCard